import { cn } from './cn';
import { Button, ButtonGroup } from './Input2';
import { Communication, Shapes } from './StrokeIcons';

type ContactCardActionsProps = {
  phone: string | null | undefined;
  phoneVerified: boolean | null | undefined;
  professionalEmail: string | null | undefined;
  professionalEmailVerified: boolean | null | undefined;
  lastUsedCadenceName?: string;
  onCall?: () => void;
  onEnrollCadence?: () => void;
};

export default function ContactCardActions({
  phone,
  phoneVerified,
  professionalEmail,
  professionalEmailVerified,
  lastUsedCadenceName,
  onCall,
  onEnrollCadence,
}: ContactCardActionsProps) {
  return (
    <ButtonGroup size="xs">
      {phone && (
        <Button
          data-testid="contact-phone-indicator"
          tooltip={
            <div
              className={cn({
                'text-mantis-400': phoneVerified === true,
                'text-fair-pink-400': phoneVerified === false,
              })}>
              {phoneVerified == null && <span>Phone: </span>}
              {phoneVerified === true && <span>Phone (Verified): </span>}
              {phoneVerified === false && <span>Phone (Invalid): </span>}
              <span>{phone}</span>
            </div>
          }
          className={cn({
            'text-mantis-500 dark:text-mantis-500': phoneVerified === true,
            'text-fair-pink-500 dark:text-fair-pink-500': phoneVerified === false,
          })}
          icon={<Communication.Phone />}
          onClick={onCall}
        />
      )}
      {professionalEmail && (
        <Button
          data-testid="contact-email-indicator"
          tooltip={
            <div
              className={cn({
                'text-mantis-400': professionalEmailVerified === true,
                'text-fair-pink-400': professionalEmailVerified === false,
              })}>
              {professionalEmailVerified == null && <span>Email: </span>}
              {professionalEmailVerified === true && <span>Email (Verified): </span>}
              {professionalEmailVerified === false && <span>Email (Invalid): </span>}
              <span>{professionalEmail}</span>
            </div>
          }
          className={cn({
            'text-mantis-500 dark:text-mantis-500': professionalEmailVerified === true,
            'text-fair-pink-500 dark:text-fair-pink-500': professionalEmailVerified === false,
          })}
          icon={<Communication.Mail01 />}
        />
      )}

      {lastUsedCadenceName && onEnrollCadence && (
        <Button
          tooltip={`Enroll in campaign: ${lastUsedCadenceName}`}
          icon={<Shapes.Cube02 />}
          size="sm"
          text
          onClick={onEnrollCadence}
        />
      )}
    </ButtonGroup>
  );
}
